import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
// const contentful = require("contentful");
// import { documentToHtnlString } from "contentful/rich-text-html-renderer";
import Client from "../contentful";
import about_banner from '../img/about-banner-img.jpg';
import about_bio_img from '../img/about-bio-img.jpg';
import team_img_4 from '../img/team-img-4.jpg';
import team_img_2 from '../img/team-img-2.jpg';
import team_img_5 from '../img/team-img-5.jpg';

import StudentCenteredPartnership from '../components/studentcenteredpartnership';
// const API = "http://localhost:8000/products/products/"

import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'

import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
let coreteamarray=[]
export default class Aboutus extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,
            presidentsphoto:"",
            presidentssName:"",
            coreteam: []
        }
     
    }

    formatData(items) {
      this.setState({
         coreteam:items
      })
      
      let tempItems = items.map(item => {
        let id = item.sys.id;
        
        
        
     
     
     
      
   })
   
   
 
   
      return tempItems;
     
      
   
   }
   formatData1(items){
  
   
   let tempItems = items.map(item => {
     let id = item.sys.id;
     
     
     if(item.fields?.presidentsPhoto){
      this.setState({
        presidentsphoto:item.fields?.presidentsPhoto?.fields?.file?.url
      })
    }
    
    // if(response.items[0].fields?.presidentssName){
      this.setState({
        presidentssName: item.fields?.presidentssName
      })
      console.log(this.state.presidentssName)
    // }
  
  
  
   
})




   return tempItems;
   }
    
      componentDidMount() {
    
      //   Client.getEntry("7l2pifXHOBLTs6M4EIjJEb")
      //   .then(entry => {
      //      console.log(entry.fields)
      //    // rich text
      //    const rawRichTextField = entry.fields.halfContent;
      //    return documentToHtmlString(rawRichTextField);

         

      //  })
      //  .then(renderedHtml => {
      //    // do something with html, like write to a file
         
      //    document.getElementById('rich-text-body').innerHTML = renderedHtml;
      //  })
      //  .catch(error => console.log(error));

      //  Client.getEntry("7l2pifXHOBLTs6M4EIjJEb")
      //   .then(entry => {

      //    console.log(entry.fields?.presidentsPhoto?.fields?.file?.url)
      //    this.setState({
      //       presidentsphoto:entry.fields?.presidentsPhoto?.fields?.file?.url,
      //       presidentssName:entry.fields?.presidentssName
      //    })

      //   })

      

        Client.getEntries({
         content_type : "coreteam"
       })
       .then(response=>{
         console.log(response.items)
         this.formatData(response.items)
       })

       Client.getEntries({
        content_type : "prsesidentsBio"
      })
      .then(response=>{
        console.log(response.items)
        this.formatData1(response.items)
        if(response.items[0].fields?.halfContent){
        const halfContent = response.items[0].fields?.halfContent
        document.getElementById('rich-text-body').innerHTML = documentToHtmlString(halfContent)
        }
        
        
      })


      }

      



    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>
           
           <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem", marginRight:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar> 


           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner carousel-slider">
            <div class="carousel-item active">	
            <img class="d-block w-100" src={about_banner} alt="First slide" />
            <div class="carousel-caption carousel-caption-center">
                <h1>About</h1>
            </div>
            </div>
        </div>
        </div>

 
<div class="container">
   <h2 class="text-center font-w-600 mt-5">President Biography</h2>
   <div class="row">
      <div class="col-lg-12">
         <h2 class="mt-5 mb-5">{this.state.presidentssName}</h2>
      </div>
      <div class="col-lg-8 mt-3">
      <div id="rich-text-body"></div>
         <div class="row mt-5">
            <div class="col-lg-6">
               {/* <div id="rich-text-body"></div> */}
            </div>
            {/* <div class="col-lg-6">
               <p>Transitioning into academic administration, Dr. Brown became associate dean of the Graduate School at Yale University and later associate dean of the faculty at Princeton University.  In 2000, Dr. Brown assumed the role of chief executive officer of Florida State University-Panama, a small U.S. university operating in Latin America...</p>
            </div> */}
         </div>
         <hr/>
         <div class="row" >
            <div class="col-lg-12 bio-social-media" >
               <ul class="list-inline" style={{display: 'inline-block',
    padding: '1rem'}}>
                 
               <Link to="/presidentsbio">
                     <li class="list-inline-item float-right color-2" ><i class="fa fa-arrow-right mr-1"></i><strong>Read More </strong></li>
                </Link>
               </ul>
            </div>
         </div>
      </div>
      <div class="col-lg-4">
         <img src={this.state.presidentsphoto} class="img-fluid m-r-35-" alt="" />
      </div>
   </div>
</div>


<div class="bg-1 p-t-50 p-b-50">
   <div class="container">
      <h2 class="font-w-600">Core Team</h2>
      <div class="row mt-5">

      {
  this.state.coreteam.map(item => (

         
         <div class="col-lg-4">
            <img src={item.fields?.image?.fields?.file?.url} class="img-fluid" />
            <div class="team">
                <p class="text-uppercase designation">
                  <span class="color-2"> {item.fields?.position} </span>
               </p> 
               <h4>{item.fields?.name}</h4>
               <p>{item.fields?.description}.</p>
               <Link 
        to= {`/coreteam/${item?.fields.slug}`}>
               <p class="btn-color"><i class="fa fa-arrow-right"></i><span class="font-w-600 ml-2">Read More</span></p>
               </Link>
            </div>
         </div>

         

  ))
    }
       
      </div>

         
         
      <div class="d-flex justify-content-center">
      <Link to="/coreteam">
      	  <button type="button" class="btn btn-primary view-team-btn mt-5">View Full Team</button>
         </Link>
      </div>
      

   </div>
</div>



<div class="container mb-5">
<h2 class="font-w-600 mt-5 mb-5">A Student Centered Partnership</h2>
      <StudentCenteredPartnership ></StudentCenteredPartnership>
   </div>
            </div>
            
        )
    }
}